import * as t from 'io-ts';
import {
  oAuthConfiguration,
  SamlConfiguration,
  ssoConfigurationCodec,
  ssoErrorLogCodec,
} from '@/services/api/resources/sso-configuration';

export type SsoConfiguration = t.TypeOf<typeof ssoConfigurationCodec>;
export type ScimErrorLog = t.TypeOf<typeof ssoErrorLogCodec>;

export const oAuthDefaultData: oAuthConfiguration = {
  authorizationUri: '',
  tokenUri: '',
  userInfoUri: '',
  clientId: '',
  clientSecret: '',
  scope: '',
};
export const samlDefaultData: SamlConfiguration = {
  entityId: '',
  nameIdFormat: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  authorizationUri: '',
  singleSignOnService: '',
  singleLogoutService: '',
  certificate: '',
};
